
const mutationtypes = Object.freeze({
  UPDATE_ENTRYEXPORT_NAVIGATION_BACKBUTTON_STATE: 'updateEntryExportNavigationBackButtonState',
  UPDATE_EXPORTLIST_SELECTED_ITEM: 'updateExportListSelectedItem',
  UPDATE_EXPORTLIST_SEARCH_STATE: 'updateExportListSearchState',
  UPDATE_EXPORTLIST_SELECTED_YEAR: 'updateExportListSelectedYear',
  UPDATE_EXPORTLIST_SELECTED_MONTH: 'updateExportListSelectedMonth'
})

export default mutationtypes
